import React from 'react';
import AboutUs from '../components/AboutUs';
import Footer from '../components/Footer';

const QuienesSomosPage = () => {
  return (
    <div className="min-h-screen">
      <AboutUs showTeamSection showHeaderText={false} />
      <Footer />
    </div>
  );
};

export default QuienesSomosPage;
